import { type PropsWithChildren, type ReactElement } from 'react';

import type { TruncationMode } from '@dynatrace/strato-components/typography';

import { ChartTooltip } from '../../../../core/components/tooltip/ChartTooltip/ChartTooltip.js';

/**
 * @internal
 */
export interface XYChartTooltipHeaderProps {
  color: string;
  name: string;
  truncationMode?: TruncationMode;
  actions?: () => ReactElement<PropsWithChildren>;
  value?: string | string[];
}

/**
 * Defines the template for the XYChart tooltip header
 * @internal
 */
export function XYChartTooltipHeader({
  color,
  name,
  truncationMode,
  actions,
  value,
}: XYChartTooltipHeaderProps) {
  return (
    <ChartTooltip.Body virtualization>
      <ChartTooltip.SeriesItem
        color={color}
        name={name}
        actions={actions}
        truncationMode={truncationMode}
        value={value}
      />
    </ChartTooltip.Body>
  );
}

(
  XYChartTooltipHeader as typeof XYChartTooltipHeader & { displayName: string }
).displayName = 'XYChartTooltipHeader';
